var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135,
    height: 135,
    viewBox: "0 0 135 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24673",
    "data-name": "Path 24673",
    d: "M1135.5-1430a67.5,67.5,0,0,0,67.5-67.5,67.5,67.5,0,0,0-67.5-67.5,67.5,67.5,0,0,0-67.5,67.5A67.5,67.5,0,0,0,1135.5-1430Z",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24672",
    "data-name": "Path 24672",
    d: "M0-1258H1920v-342H0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24676",
    "data-name": "Path 24676",
    d: "M1136.106-1498.143c-5.626.022-8.977-7.987-3.878-11.859a6.98,6.98,0,0,1,4.318-1,6.9,6.9,0,0,1,3.186.531c1.651.84,2.5,2.809,2.783,4.7a6.726,6.726,0,0,1-4.714,7.379A6.328,6.328,0,0,1,1136.106-1498.143Zm.122-1.292a6.212,6.212,0,0,0,1.492-.239,4.887,4.887,0,0,0,2.965-2.41,6.937,6.937,0,0,0,.5-4.005,6.17,6.17,0,0,0-1.387-3.453,4.7,4.7,0,0,0-2.859-1.357c-1.88-.246-4.443-.131-5.9,1.357a5.081,5.081,0,0,0-1.307,3.291,7.193,7.193,0,0,0,1.467,4.857,6.281,6.281,0,0,0,5.032,1.959Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24679",
    "data-name": "Path 24679",
    d: "M1146.867-1515.516A16.384,16.384,0,0,0,1135.5-1520a16.379,16.379,0,0,0-11.365,4.484c-5.618,5.351-6.316,15.418-1.512,21.517l12.877,17.713,12.857-17.688C1153.183-1500.1,1152.485-1510.165,1146.867-1515.516Zm.554,20.623-11.277,16.036-11.3-16.061c-4.274-5.611-3.661-14.828,1.312-19.724a14.135,14.135,0,0,1,9.983-4.072,14.139,14.139,0,0,1,9.984,4.072C1151.1-1509.746,1151.713-1500.529,1147.421-1494.893Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_74259",
    "data-name": "Group 74259",
    transform: "translate(-702.039 -4609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49649",
    "data-name": "Group 49649",
    transform: "translate(-365.961 6174)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49648",
    "data-name": "Group 49648",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24671",
    "data-name": "Path 24671",
    d: "M1063-1570h145v145H1063Z",
    fill: "#f19796"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49651",
    "data-name": "Group 49651",
    transform: "translate(-365.961 6174)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49650",
    "data-name": "Group 49650",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24674",
    "data-name": "Path 24674",
    d: "M1124.714-1516h22.857v22.857h-22.857Z",
    fill: "#003160"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49652",
    "data-name": "Group 49652",
    transform: "translate(763.754 4663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M6.392,12.857C.766,12.879-2.586,4.87,2.514,1A6.981,6.981,0,0,1,6.832,0a6.9,6.9,0,0,1,3.186.531c1.651.84,2.5,2.809,2.783,4.7a6.724,6.724,0,0,1-4.714,7.379A6.326,6.326,0,0,1,6.392,12.857Zm.122-1.292a6.2,6.2,0,0,0,1.492-.239,4.885,4.885,0,0,0,2.965-2.41,6.94,6.94,0,0,0,.5-4.006,6.173,6.173,0,0,0-1.387-3.453A4.7,4.7,0,0,0,7.224.1C5.345-.145,2.782-.03,1.322,1.458A5.079,5.079,0,0,0,.015,4.749,7.2,7.2,0,0,0,1.481,9.606a6.279,6.279,0,0,0,5.032,1.959Z",
    fill: "none",
    stroke: "#003160",
    strokeWidth: 1.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_49654",
    "data-name": "Group 49654",
    transform: "translate(-365.961 6174)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_49653",
    "data-name": "Group 49653",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24677",
    "data-name": "Path 24677",
    d: "M1114.429-1525h42.142v53.714h-42.142Z",
    fill: "#003160"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49655",
    "data-name": "Group 49655",
    transform: "translate(753.469 4654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M27.438,4.484A16.38,16.38,0,0,0,16.073,0,16.379,16.379,0,0,0,4.708,4.484C-.91,9.835-1.608,19.9,3.2,26L16.073,43.714,28.931,26.026C33.754,19.9,33.056,9.835,27.438,4.484Zm.554,20.623L16.715,41.143,5.42,25.082C1.147,19.471,1.759,10.254,6.732,5.358a14.274,14.274,0,0,1,19.967,0C31.672,10.254,32.285,19.471,27.992,25.107Z",
    fill: "none",
    stroke: "#003160",
    strokeWidth: 1.3
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.161f2f1cf2c0b434f1e3a8102fbd66fa.svg";
export { ForwardRef as ReactComponent };